import {Injectable} from '@angular/core';
import {ModalComponent} from './modal.component';
import {ModalConfig} from './modal.config';

@Injectable({providedIn: 'root'})
export class ModalService {

  modal: ModalComponent;

  set(modal: ModalComponent) {
    this.modal = modal;
  }

  open(config: ModalConfig) {
    this.modal.open(config);
  }

  close(id: string) {
    this.modal.close();
  }
}
